import React, { memo, useEffect, useMemo, useState } from 'react';
import Cascader from 'rc-cascader';
import 'rc-cascader/assets/index.less';
import MIcon from '../m-icon/MIcon';
import MError from '../m-error/MError';

function TableCityCascader({
                               data,
                               placeholder = 'Select',
                               className,
                               label,
                               state,
                               setState,
                               name,
                               itemKey = name,
                               inputClassName = '',
                               error = null
                           }) {
    const [inputValue, setInputValue] = useState('');
    const [dropdownVisible, setDropdownVisible] = useState(false);

    useEffect(() => {
        if (!state[name]) {
            setInputValue('');
        }
    }, [name, state]);

    function transformData(data = []) {
        const regionsMap = {};
        data.forEach(item => {
            const [regionName, cityName] = item.name.split('//');

            if (!regionsMap[regionName]) {
                regionsMap[regionName] = {
                    label: regionName,
                    value: regionName.toLowerCase().replace(/\s+/g, '_'),
                    [name]: item[itemKey],
                    children: []
                };
            }

            if (cityName) {
                regionsMap[regionName].children.push({
                    label: cityName,
                    value: cityName.toLowerCase().replace(/\s+/g, '_'),
                    [name]: item[itemKey]
                });
            }
        });

        return Object.values(regionsMap);
    }

    const options = useMemo(() => transformData(data), [data]);


    return (
      <div className={`flex flex-col box-border ${className}`}>
          {label && (
            <p className='text-xs font-normal text-black/[0.5] my-2'>
                {label}
            </p>
          )}
          <Cascader
            options={options}
            onChange={(value, selectedOptions) => {
                setInputValue(selectedOptions.map(o => o.label).join(' '));
                setState({ ...state, [name]: selectedOptions[selectedOptions.length - 1][name] });
            }
            }
            onDropdownVisibleChange={(visible) => setDropdownVisible(visible)}
            searchValue={inputValue}
            dropdownClassName={'!border-black'}
          >
              <div className='relative'>
                  <input
                    className={`h-10 rounded-lg px-3 text-sm border border-black/[0.1] cursor-default w-full placeholder:text-black overflow-ellipsis pr-7 ${inputClassName} ${dropdownVisible ? 'cascader-open' : ''}`}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={e => {
                        setInputValue(e.target.value);
                    }}
                    autoComplete={'new-password'}
                  />
                  <MIcon
                    type={'arrowDown'}
                    className={`absolute text-bla right-3 top-1/2 transform -translate-y-1/2 text-black font-bold pointer-events-none transition-transform ${dropdownVisible ? 'rotate-180' : ''}`}
                  />
              </div>
          </Cascader>
          {error && error !== true && <MError errorMessage={error}/>}
      </div>
    );
}

export default memo(TableCityCascader);
